/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;padding-top:20px}"];
export { styles as styles };
